<template>
  <div class="calendarPage" v-if="!showLoad">
    <Calendar
      ref="Calendar"
      @choseDay="clickDay"
      :markDateMore="unusualArr"
      @changeMonth="changeDate"
      :futureDayHide="currentDay"
      class="card"
    ></Calendar>
    <p class="fgx"></p>
    <div class="signInfo clearfix">
      <span class="fl currentDate">{{baseDate.belongTime?baseDate.belongTime.substring(5):'暂无'}}</span>

      <div class="signDetail fl">
        <div class="signMsg" v-if="baseData != null">
          <div
            class="signMsgList clearfix"
            v-if="baseData.signInPlace != null && baseData.signInResult!=null && baseData.signInTime!=null"
          >
            <span class="commuter fl baseLine">上</span>
            <p class="fl">
              <span>
                打卡时间 {{baseData.signInTime}}
                <em>（上班时间 {{baseData.usignInTime}}）</em>
              </span>
              <span>
                <img :src="baseUrl+'img/company/topIcon01.png'" alt />
                <em>{{baseData.signInPlace}}</em>
              </span>
              <span
                :class="[baseData.signInResult == 'normal' ? 'styleTrue':'styleFalse']"
              >{{baseData.signInResult == 'normal' ? '正常' : '迟到 '+ Math.abs(baseData.lateTime) +' 分钟'}}</span>
              <!-- <span
                v-if="baseData.signInResult !='normal'"
                class="leaveHoliday"
                @click="getLeaveApply"
              >
                提交假勤申请
                <i>&rsaquo;</i>
              </span>-->
            </p>
          </div>
          <div
            class="signMsgList clearfix"
            v-if="baseData.signOutPlace != null && baseData.signOutResult!=null && baseData.signOutTime!=null"
          >
            <span class="commuter fl">下</span>
            <p class="fl">
              <span>
                打卡时间 {{baseData.signOutTime== null ? "暂未打卡": baseData.signOutTime}}
                <em>（下班时间 {{baseData.usignOutTime}}）</em>
              </span>
              <span>
                <img :src="baseUrl+'img/company/topIcon01.png'" alt />
                <em>{{baseData.signOutPlace == null ? '暂无获取到地址' : baseData.signOutPlace }}</em>
              </span>
              <span
                :class="[baseData.signOutResult == 'normal' ?'styleTrue':'styleFalse']"
                v-if="baseData.signOutResult!=null"
              >{{baseData.signOutResult == 'normal' ? '正常' : '早退 '+ Math.abs(baseData.earlyTime)+' 分钟'}}</span>
              <!-- <span
                v-if="baseData.signOutResult!='normal'"
                class="leaveHoliday"
                @click="getLeaveApply"
              >
                提交假勤申请
                <i>&rsaquo;</i>
              </span>-->
            </p>
          </div>
        </div>

        <!-- <span class="commuter">下</span> -->
      </div>
      <div class="nonePage" v-if="baseData == null">
        <img :src="baseUrl+'empty.png'" alt />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getCurData, dateFormat } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import Calendar from "vue-calendar-component"; //引入vue日历
export default {
  name: "calendar",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      orgId: "",
      signType: true,
      outType: false,
      unusualArr: [
        // { date: "2020/05/05", className: "mark2" }
      ],
      currentDay: "", //时间戳长度是 10 位
      currentDate: "", //当前te年月日
      currentDate: "", //当前年月日
      baseDate: {
        orgId: "",
        uid: "",
        belongTime: "",
      },
      baseData: {
        orgId: "",
        belongTime: "", //当前日期
        uid: "",
      },
      baseMounth: {
        orgId: "",
        belongTime: "", //当前月份
        uid: "",
      },
      clineType: getDeviceType(),
    };
  },
  components: {
    Calendar,
  },
  mounted() {
    this.$nextTick(() => {
      this.baseDate.orgId = this.$route.query.orgId;
      this.baseMounth.orgId = this.$route.query.orgId;
      this.baseData.orgId = this.$route.query.orgId;
      this.currentDate = getCurData();
      this.setShowLoad(false); //加载状态，默认为true加载
      this.currentDay = String(Date.parse(new Date())).substr(0, 10);
      this.initPage();
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      if (_this.userinfo && _this.userinfo.id) {
        _this.baseDate.uid = _this.userinfo.id;
        _this.baseMounth.uid = _this.userinfo.id;
        _this.baseData.uid = _this.userinfo.id;
        _this.clickDay(this.currentDate);
        _this.getAttendanceCalendarState(this.currentDate);
      }
    },
    getAttendanceCalendarState(mounth) {
      //当前月份异常数据
      let _this = this;
      _this.baseMounth.belongTime = this.changeFormatMounth(mounth);
      _this.$api.userCenter.user.myAttendance
        .mounthSign(_this.baseMounth)

        .then((res) => {
          if (res.code == "1") {
            if (res.data != null) {
              for (let i = 0; i < res.data.length; i++) {
                if (!res.data[i].state) {
                  let newobj = {
                    date: res.data[i].belongTime,
                    className: "mark2",
                  };
                  _this.unusualArr.push(newobj);
                }
              }
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeDate(data) {
      //左右点击切换月份
      this.getAttendanceCalendarState(data);
    },
    clickDay(date) {
      //点击日期,默认当前天数
      let _this = this;

      console.log(date);
      
      _this.$set(_this.baseDate, "belongTime", _this.changeFormatDate(date));
      console.log("baseDate=====" + JSON.stringify(_this.baseDate));
      _this.$api.userCenter.user.myAttendance
        .daySign(_this.baseDate)
        .then((res) => {
          if (res.code == "1") {
            if (res.data.length == 0) {
              _this.baseData = null;
            } else {
              // _this.baseData = res.data[0];
              _this.baseData = newApi.assign({}, _this.baseData, res.data[0]);
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFormat(name) {
      //字符串截取年月
      //获取年月
      const _index = name.lastIndexOf("-");
      return _index >= 0 ? name.substring(0, _index) : "";
    },

    changeFormatDate(date) {
      //日期转换
      let newDate = dateFormat(new Date(date));
      return newDate;
    },
    changeFormatMounth(mounth) {
      //月份转换
      let newMounth = this.getFormat(String(mounth).replace(/\//g, "-"));
      newMounth = dateFormat(new Date(newMounth)).substring(0, 7);
      return newMounth;
    },
    getLeaveApply() {
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      if (this.clientType == "android") {
        window.android.getInfo(
          108,
          "" + jumpUrl + "/dhome-lzz-lzt-h5/#/leaveApply?"
        );
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(
          "" + jumpUrl + "/dhome-lzz-lzt-h5/#/leaveApply?"
        );
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler(val) {
        if (val && val.id) {
          let _this = this;
          _this.baseDate.uid = val.id;
          _this.baseMounth.uid = val.id;
          _this.baseData.uid = val.id;
          _this.clickDay(this.currentDate); //当天签到详情
          _this.getAttendanceCalendarState(this.currentDate); //当前月份异常数据
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.calendarPage {
  width: 100%;
  height: 100%;
  font-family: "PingFangSC-Regular", "PingFang SC";
  background-color: #fff;
  .fgx {
    display: block;
    width: 100%;
    height: 5%;
    background-color: #f6f6f6;
  }
  .card {
    min-height: 50%;
    .wh_content_all {
      height: 100%;
    }
    .wh_content[data-v-2ebcbc83] {
      padding: 0;
    }
    .wh_content_item[data-v-2ebcbc83],
    .wh_content_item_tag[data-v-2ebcbc83] {
      width: 14.25%;
    }
    .wh_content_item {
      .wh_item_date {
        font-size: 15px;
        font-weight: bold;
        color: #000;
        line-height: 21px;
      }
      .wh_item_date.wh_other_dayhide {
        opacity: 0.2;
      }
      .wh_item_date.wh_isToday[data-v-2ebcbc83] {
        background-color: #fff;
        border-radius: 50%;
        color: #3c78f9;
        font-size: 22px;
      }
      .wh_chose_day[data-v-2ebcbc83] {
        background: #3c78f9;
        border-radius: 50%;
        color: #fff;
      }
      .wh_item_date.mark1 {
        background: #e5ecfc;
        color: #5d8ff9;
        border-radius: 50%;
      }
      .wh_item_date.mark1.wh_chose_day[data-v-2ebcbc83],
      .wh_item_date.mark2.wh_chose_day[data-v-2ebcbc83] {
        background: #3c78f9;
        border-radius: 50%;
        color: #fff;
      }
      .wh_item_date.mark2 {
        background: #fce7cc;
        color: #fca032;
        border-radius: 50%;
      }
      .wh_top_tag {
        color: #000;
      }
    }

    .wh_top_changge {
      .wh_jiantou1 {
        border-top: 2px solid #3c78f9;
        border-left: 2px solid #3c78f9;
      }
      .wh_jiantou2 {
        border-top: 2px solid #3c78f9;
        border-right: 2px solid #3c78f9;
      }

      .wh_content_li {
        color: #000;
        line-height: 17px;
      }
    }
  }
  /*日历点击*/
  .wh_content_item .wh_chose_day[data-v-2ebcbc83] {
    background-color: transparent;
  }
}
.card div:nth-child(1) {
  background-color: #fff;
  padding-bottom: 0;
}
.signInfo {
  margin-top: 25px;
  width: 100%;
  min-height: 45%;
  padding: 16px 14px 0;
  box-sizing: border-box;
  position: relative;
  .currentDate {
    width: 40px;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #9f9c9c;
    line-height: 17px;
  }
  .signDetail {
    margin-left: 12px;
    position: relative;
    .commuter {
      display: inline-block;
      width: 20px;
      height: 20px;
      font-size: 12px;
      color: #fff;
      background-color: #bebebe;
      line-height: 20px;
      border-radius: 50%;
      text-align: center;
    }
    .signMsg {
      .commuter {
        position: relative;
      }
      .signMsgList {
        margin-bottom: 50px;
        p {
          margin-left: 13px;
          width: 255px;
          span {
            display: block;
            margin-bottom: 6px;
            font-size: 12px;
            em {
              display: inline-block;
              font-size: 10px;
              color: #aaa;
              line-height: 17px;
              font-weight: normal;
            }
          }
          span:first-child {
            height: 20px;
            font-size: 14px;
            color: #000;
            line-height: 20px;
            word-break: keep-all;
            white-space: nowrap;
          }
          span:nth-child(2) {
            position: relative;
            padding-left: 15px;
            img {
              display: inline-block;
              width: 11px;
              height: 11px;
              position: absolute;
              top: 2px;
              left: 0;
            }
            em {
              display: inline-block;
              font-size: 12px;
              color: #aaa;
              line-height: 17px;
              font-weight: normal;
            }
          }
          span.leaveHoliday {
            margin-top: 8px;
            height: 14px;
            font-size: 10px;
            color: rgba(86, 113, 171, 1);
            line-height: 14px;
            i {
              font-size: 16px;
              line-height: 16px;
            }
          }
          span.styleTrue {
            display: inline-block;
            padding: 2px 13px;
            color: #fff;
            background-color: #3c78f9;
            font-size: 8px !important;
            border-radius: 12px;
          }
          span.styleFalse {
            display: inline-block;
            padding: 2px 13px;
            display: inline-block;
            color: #fff;
            background-color: #fc8f0c;
            border-radius: 12px;
          }
        }
      }
    }
  }
  .nonePage {
    width: 120px;
    height: 135px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -67px;
    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>